import React, { Component } from 'react'
import *as s from './Button.module.css'
export default class Button extends Component {
    render() {
        return (
            <div className={s.wrapper}>
                 <button className={s.button}>
                     <span>{this.props.buttonText}</span>
                </button>
            </div>
          
        )
    }
}
